import React, {useState} from 'react';
import {
    HiBarsArrowDown,HiArrowRightOnRectangle,
  } from "react-icons/hi2";
  import { NavComponent } from '../navigationComponents/NavComponent';
  import styled from 'styled-components';
  const StyledButton = styled.button`

  justify-content: center;
  padding: 10px 20px;
  
    background-color: #black;
    color: white;
    border: 2px solid #9a5ecb; /* Added border color */
    border-radius: 15px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
  
    &:hover {
      background-color: #9a5ecb;
      transform: scale(1.05); /* Slight zoom effect */
    }
  
    svg {
      margin-left: 8px; /* Space between text and icon */
      font-size: 20px;
    }
  `;

function NFTFactory()
{
   const [openTokenFactory, setOPenTokenFactory] = useState(false);
   const toggle_TokenFactory = () => {
    setOPenTokenFactory(!openTokenFactory);
  };
  const [openOldtimerCol, setOpenOldtimerCol] = useState(false);
  const toggle_OldtimerCol = () => setOpenOldtimerCol(!openOldtimerCol);
  const [openVolvoCol, setOpenVolvoCol] = useState(false);
  const toggle_VolvoCol = () => setOpenVolvoCol(!openVolvoCol);

   return (
       <main>
           <div id="divHomepage" className='homepageDesign'>
           
           <NavComponent/>
                
           <div id="NFTFactoryDIV" >
            <h1 className="factoryTitle"> The NFT Factory </h1>

            <div style={{ borderTop: "2px solid #333 ", marginLeft: 20, marginRight: 20 }}></div>
            <div id="internalNav" className="intpageNavigation">
                  <p className='ulMidP'>DefinitionPage: </p>
                  <ul className='intpageNavigation'>
                      <li className='intpageNavigation'> <a href="#NFTGeneral" className='intpageNavigation'>#DefinitionsPage: NFT - Non Fungible Token</a></li>
                      <li className='intpageNavigation'> <a href="#WhatCanBecomeAnNFT" className='intpageNavigation'>#DefinitionsPage: What Can Become An NFT</a></li>
                      <li className='intpageNavigation'> <a href="#Prerequisites" className='intpageNavigation'>#DefinitionsPage: Prerequisites</a></li>
                      <li className='intpageNavigation'> <a href="#Copyright" className='intpageNavigation'>#DefinitionsPage: Copyright</a></li>   
                  </ul>
                  <button onClick={toggle_TokenFactory} className="factoryTitle"> <HiBarsArrowDown/>
                          {'Press to fall down the NFT Factory - DefinitionsPage'} 
                  </button>
                  <br/>
                  <br/>
                  <div style={{ borderTop: "2px solid #333 ", marginLeft: 20, marginRight: 20 }}></div>
                  <p className='ulMidP'>Projects: </p>
                  <ul> 
                      <li className='intpageNavigation'> <a href="#OldtimerCol" className='intpageNavigation'>#Project0: Oldtimer Collection</a></li>
                      <li className='intpageNavigation'> <a href="#volvoCol" className='intpageNavigation'>#Project1: Volvo Collection (upcoming)</a></li>
                  </ul>
            </div>

            <br/>
            <br/>
            <div style={{
              textAlign: 'center',
              margin: 'auto',
              padding: '15px',
              border: '1px solid #ccc', // Light gray border
              borderRadius: '10px', // Rounded corners
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Subtle shadow
              backgroundColor: 'transparent', // Transparent background
              width: '70%'

            }}>
              <h1> Do you want to be the owner of your own NFT? </h1>
              <p></p>
              <br/>
              <p>Send us your artwork, your music, your video, your idea, your project, your oldtimer or whatever you want to turn into an NFT. We will create it for you and send it back to you as a token on the Network you'd wish for.<br/>
                <br/>— with the metadata you'd like to store along.</p>
              <br />
              <a href="/Shop" style={{ textDecoration: 'none' }}>
                <StyledButton>
                Select your Token Package
                  <HiArrowRightOnRectangle />
                </StyledButton>
              </a> 
            </div>
            <br/>

            {openTokenFactory && (
              <>
                <div className="factoriesDesign" id="NFTGeneral">
                  
                      <h2>NFT - Non Fungible Token</h2>
                      <p>An NFT is distingshible from the others, unique and cannot be replaced. It is also not splittable (e.g. 1 Bitcoin can be split into 2 0.5 Bitcoins, this is not possible for NFT).</p>
                      <p>From technical perspective: NFTs are simply data existing on the blockchain to which some address has ownership. NFT tokens can
                        be traded, and since all transactions on the blockchain are public, you can check the ownership history of a given NFT.
                      </p>
                      <p>Most common mistake: the owner of a given NFT is not the owner of the image or other image "attached" to the NFT, or the copyright to it. 
                        He only owns the data on the blockchain. The data can lead, as example, to an extended server where the image is stored/hosted.
                      </p>
                      <p>NFTs are mainly seen as investments, or like Pokemon-cards: something to collect and trade.</p>
                      <p>NFTs can be copied. You can create an NFT leading to an image on the same server address, but by tracking transcations, it will be clear whose
                        NFT came first. The transaction history on the blockchain is never erased, never lost!
                      </p>
                      <p>Most known marketplaces: OpenSea, Rarible, CryGIA. We store the NFTs themselves on our wallet, just like other tokens.</p>
                      <p>Information by Piotr Boron</p>

                      <p style={{fontStyle:'italic', fontSize:12}}>Main source of information:   Boron Piotr. Your own token. 2023 </p>
                </div>
                <div className="factoriesDesign" id="WhatCanBecomeAnNFT">
                  <p>You may have heard that anything can be turned into an NFT, which is completely true. 
                    However, before converting them to NFTs, one must first create a digital copy of the object in question, 
                    be it a physical structure, a flying object, or a moving stream. If the thing you want to convert is already 
                    in digital format, you won’t have any trouble; if not, you might need to take a picture of it or record it if it’s a
                    sound or in motion.
                  </p>
                </div>
                <br/>
                <br/>
                <div className="factoriesDesign" id="Prerequisites">
                  <h2>Prerequisites</h2>
                  <p>First thing you need is a Crpyto Wallet - here your NFTs will be stored. Recommanded is MetaMask. You can connect 
                    the Metamask Wallet to the BNB Chain Network.
                  </p>
                  <p>Second step is to fund your wallet - you will need a few cryptos (BNBs) to pay the transaction fees.</p>
                  
                      
                  <p style={{fontStyle:'italic', fontSize:12}}>Main source of information: 
                        <a href="https://www.investing.com/news/cryptocurrency-news/how-to-create-and-sell-nfts-a-stepbystep-guide-for-beginners-2852388?utm_source=google&utm_medium=cpc&utm_campaign=19313816760&utm_content=642156036452&utm_term=dsa-1463805041937_&GL_Ad_ID=642156036452&GL_Campaign_ID=19313816760&ISP=1&npl=1&gad_source=1&gclid=CjwKCAjww_iwBhApEiwAuG6ccDg7cSZcHpo-xhMmQ3EsbgW8cP18erW8HIjJQvIcOAyo1xt-cjYTkBoCDuwQAvD_BwE">
                          linked article from www.investing.com</a>
                      </p>
                </div>
                <br/>
                <br/>
                <div className="factoriesDesign" id="Copyright">
                  <h2>Copyright and Stealing NFT Content</h2>
                  <p>Copyright applies to NFTs just as it does to any other creative work, and using someone else's work without 
                    permission can have legal consequences. Therefore, to minimize risk, the creator should ensure that he or she
                    has the right to use the content for the NFTs.

                    The best way to protect yourself and your NFTs is to secure the right to use the content for the NFTs. 
                    In other words, the creator should either own the rights to the content or have permission from the original creator.

                    Stealing someone else's work not only puts one at risk of legal repercussions, it also harms the original creator. 
                    Therefore, it's important to respect other people's work and obtain proper permission before using anything that’s 
                    not yours to create an NFT.
                </p>
                      
                  <p style={{fontStyle:'italic', fontSize:12}}>Main source of information: 
                        <a href="https://academy.binance.com/en/articles/how-to-create-an-nft#What-Is-an-NFT?">
                          linked article from www.academy.binance.com</a>
                      </p>
                </div>
            </>
          )}
            <br/>
            <br/>
          
            <div id="OldtimerCol" className="factoriesDesign" style={{
              background: "#eddcd3",
              backgroundImage: "radial-gradient(circle, rgba(237,220,211,1) 0%, rgba(228,247,247,1) 100%)",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              padding: "32px 16px",
              margin: "32px auto",
              maxWidth: 800,
              color: "#333"
            }}>
              <h1 style={{ color: "#b86fec", textAlign: "center", fontSize: "2.2rem", marginBottom: 0 }}>PROJECT 0: Oldtimer Collection - Give your oldtimer some high-tech!</h1>
              <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
                <button onClick={toggle_OldtimerCol} className="factoryTitle" style={{ background: "#b86fec", color: "#fff", border: "none", borderRadius: 12, padding: "10px 24px", fontWeight: 600, fontSize: 16, cursor: "pointer", boxShadow: "0 2px 8px rgba(186,111,236,0.10)" }}>
                  {openOldtimerCol ? 'Hide Project Details' : 'Show Project Details'}
                </button>
              </div>
              {openOldtimerCol && (
                <>
                  <img src={require('../pictures/OldTimerAILogo.jpeg')} alt="Oldtimer NFT Logo" style={{ display: "block", margin: "24px auto 8px", width: 120, height: 120, borderRadius: "50%", objectFit: "cover", boxShadow: "0 2px 12px rgba(186,111,236,0.12)" }} />
                  <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
                    <a href="https://opensea.io/collection/oldtimernftcollection" target="_blank" rel="noopener noreferrer" style={{ color: "#b86fec", fontWeight: 500 }}>
                      View the Oldtimer NFT Collection on OpenSea
                    </a>
                  </div>
                  <div style={{ textAlign: "center", margin: "24px 0" }}>
                    <strong>Want your Oldtimer to become part of the collection?</strong>
                    <br/>
                    <span style={{ fontSize: "1.1rem" }}>Send us your car's photo and details to <a href="mailto:emb@cryptobartl.com" style={{ color: "#b86fec" }}>emb@cryptobartl.com</a>!</span>
                  </div>
                  <ul style={{
                    listStyle: "none", padding: 0, margin: "24px 0", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px"
                  }}>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🚗</span>Turn your classic car into digital art
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🔗</span>Forever on the blockchain
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🖼️</span>Unique NFT for your vehicle
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>💶</span>One-time fee: 250€
                    </li>
                  </ul>
                  <div style={{ textAlign: "left", margin: "24px auto", maxWidth: 600 }}>
                    <strong>Your application must include:</strong>
                    <ul>
                      <li>Description (e.g. The perfect oldtimer one could imagine!)</li>
                      <li>Brand (e.g. Porsche)</li>
                      <li>Model (e.g. 928)</li>
                      <li>Year (e.g. 1980)</li>
                      <li>VIN</li>
                    </ul>
                    <strong>Optional:</strong>
                    <ul>
                      <li>Owner</li>
                      <li>History</li>
                      <li>Condition</li>
                      <li>Mileage</li>
                      <li>Power</li>
                      <li>Equipment</li>
                    </ul>
                    <p>Include your crypto wallet address. If you need a wallet, we can create one for you for an additional 250€.</p>
                    <p>After review and approval, your NFT will be created and sent to your wallet. Only the first 80 applications will be accepted.</p>
                    <p style={{fontStyle: "italic", fontSize: "small"}}>By ordering, you agree to the <a href="https://cryptobartl.com/Legals" style={{ color: "#b86fec" }}>Terms and Conditions</a> and <a href="https://cryptobartl.com/Legals" style={{ color: "#b86fec" }}>Privacy Policy</a>.</p>
                  </div>
                  <div style={{ textAlign: "center", margin: "24px 0" }}>
                    <a href={require('../requestForm/NFTFormularENG.pdf')} target="_blank" rel="noopener noreferrer">
                      <button style={{ fontWeight: "bold", border: "2px solid black", cursor: "pointer", backgroundColor: "#FF0000", color: "white", padding: "15px 20px", borderRadius: "10px", textAlign: "center", fontSize: "16px", transition: "transform 0.2s ease, background-color 0.3s ease" }}>
                        Click here to Open <br /><br />
                        <span style={{ fontSize: "24px", marginBottom: "10px" }}>📄</span>
                        <br />the NFT Request Form <br />
                        <span style={{ color: "black", fontSize: "14px" }}>(English version)</span>
                      </button>
                    </a>
                    <span style={{ margin: "0 8px" }}> </span>
                    <a href={require('../requestForm/NFTFormularDE.pdf')} target="_blank" rel="noopener noreferrer">
                      <button style={{ fontWeight: "bold", border: "2px solid black", cursor: "pointer", backgroundColor: "#FF0000", color: "white", padding: "15px 20px", borderRadius: "10px", textAlign: "center", fontSize: "16px", transition: "transform 0.2s ease, background-color 0.3s ease" }}>
                        Click here to Open <br /><br />
                        <span style={{ fontSize: "24px", marginBottom: "10px" }}>📄</span>
                        <br />the NFT Request Form <br />
                        <span style={{ color: "black", fontSize: "14px" }}>(German version)</span>
                      </button>
                    </a>
                  </div>
                </>
              )}
            </div>

            <div id="volvoCol" className="factoriesDesign" style={{
              background: "#e3e6ec",
              backgroundImage: "radial-gradient(circle, #e3e6ec 0%, #cfd8dc 100%)",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
              padding: "32px 16px",
              margin: "32px auto",
              maxWidth: 800,
              color: "#333"
            }}>
              <h1 style={{ color: "#4a90e2", textAlign: "center", fontSize: "2.2rem", marginBottom: 0 }}>PROJECT 1: Volvo Collection - upcoming! Stay tuned!</h1>
              <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
                <button onClick={toggle_VolvoCol} className="factoryTitle" style={{ background: "#4a90e2", color: "#fff", border: "none", borderRadius: 12, padding: "10px 24px", fontWeight: 600, fontSize: 16, cursor: "pointer", boxShadow: "0 2px 8px rgba(74,144,226,0.10)" }}>
                  {openVolvoCol ? 'Hide Project Details' : 'Show Project Details'}
                </button>
              </div>
              {openVolvoCol && (
                <>
                  <div style={{ textAlign: "center", margin: "24px 0" }}>
                    <br/>
                    <br/>
                    <h1>Upcoming!</h1>
                    <br/>
                    <br/>
                    <br/>
                    <strong>Be among the first to join the Volvo NFT Collection!</strong>
                    <br/>
                    <span style={{ fontSize: "1.1rem" }}>This project will allow Volvo enthusiasts to immortalize their cars on the blockchain as unique NFTs.</span>
                  </div>
                  <ul style={{
                    listStyle: "none", padding: 0, margin: "24px 0", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px"
                  }}>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(74,144,226,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🚙</span>Turn your Volvo into digital art
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(74,144,226,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🔗</span>Forever on the blockchain
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(74,144,226,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>🖼️</span>Unique NFT for your Volvo
                    </li>
                    <li style={{display: "flex", alignItems: "center", background: "#fff", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(74,144,226,0.08)", fontWeight: 500, color: "#333"}}>
                      <span style={{fontSize: "1.3em", marginRight: 8}}>⏳</span>Coming soon: application details & pricing
                    </li>
                  </ul>
                  <div style={{ textAlign: "center", margin: "24px 0", color: "#4a90e2", fontWeight: 600 }}>
                    Stay tuned for more information and get ready to showcase your Volvo in the digital world!
                  </div>
                </>
              )}
            </div>

             
          </div> 
      
            <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
            <p style={{textAlign: "center"}}>Copyright © 2025 CryptoBartl</p>

           </div>
       </main>
   )
}

export default NFTFactory;